import { combineReducers } from 'redux';
import tasks from './tasks';
import release from './release';

export default combineReducers({
  tasks,
  release,
});
